import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cbasic(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>    
    
     <Sides/>
       <Helmet>
 
       <title>Get Started with C++ Programming: First Program Tutorial for Beginners | CodeExampler</title>
<meta name="description" content="Learn how to write your first program in C++ with CodeExampler's free tutorial for beginners. Our step-by-step guide covers the basics of computer programming, including the 'Hello, World! or hello world program in cpp' program."/>
<meta name="keywords" content="C++ programming, first program, hello world program,hello world program in cpp,basic c++ programs, computer programming basics, C++ tutorial for beginners, learn free programming tutorials, CodeExampler"/>
<link rel="canonical" href="https://www.codeexampler.com/cpp-first-program" />
 </Helmet>
 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">First Program in C++ OR Hello world program in c++</h1><br/>
    <div className="first">
        <a href="/cpp-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
   
    <h2 className="mt-4 mh2">The basic program of C++ for beginners or Hello world program in C++:<br/>
</h2>
<p className="mt-4 para">In essential for c++ programming, no blanks space use within a variable, constant, or keyword.<br/>
All statements enter in small case letters.<br/>
All Code must end all C++ statements with a ( ; )<br/>
(;) means that statement is terminating<br/>
Main() – this is a collective name given to a set of statements. main() is a function, and Every function has a pair of parentheses ( ) Every function has a couple of parentheses ( )<br/>
Clrscr() – is used to clear screen<br/>
and code finish by use (<span className="bold">return 0 ;</span>).<br/>
There are essential points in the c++ programming language.<br/>
</p><br/>

<h2 className='head3'>Basic for c++ programming syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-6"> Statement1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-6"> Statement1</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
            
          </code>
        </pre>
      </div>



<h2 className='head3'>Q-Write a hello world program in C++ example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-6"> // </span>
            <span className="qwerty-4">cout </span>
         
            <span className="qwerty-5">is used to outputs the values on the screen</span>
            {"\n"}
            <span className="qwerty-6"> cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">hello world </span>
            <span className="qwerty-11">program </span>
            <span className="qwerty-10">in </span>
            <span className="qwerty-11">c++</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">hello world </span>
              <span className="qwerty-2">program </span>
              <span className="qwerty">in</span>
              <span className="qwerty-10"> C++</span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>


<h3 className="mt-4 mh3"> Escape sequence character:
</h3>
<h4 className="mt-4 ">\t – tab(gap b/w two characters)<br/>
\n – newline<br/>
\b – backspace<br/>
\" – "<br/>
\\ - \<br/>
\0 – null used In a string<br/>
</h4>

<p className="mt-4 para"><span className="bold" >Important</span>-each escape sequence  character occupied only one bite.
</p>



<h2 className='head3'>Q-Write a program to give sports name output for c++ programming example?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-11">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}
            <span className="qwerty">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty">std</span>
            <span className="qwerty-3">; </span>
            {"\n"}
            <span className="qwerty-11"> int </span>
            <span className="qwerty-2">main</span>
              <span className="qwerty-3">( )</span>
            {"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"} 
            <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty">sports</span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-5">";</span>
            {"\n"}
            <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-3">1,football</span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-5">";</span>
            {"\n"}
            <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-4">2,badminton</span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-5">";</span>
            {"\n"}
            <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-5">3,tennis \</span>
            <span className="qwerty-6">t 4,cricket</span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-5">";</span>
            {"\n"}
              <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-5">\n</span>
            <span className="qwerty-5">";</span>
            {"\n"}
            <span className="qwerty-10">cout </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10">hello world </span>
            <span className="qwerty-11">program </span>
            <span className="qwerty-10">in </span>
            <span className="qwerty-11">c++</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-4"> return</span>
              <span className="qwerty-2"> 0</span>
              <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-3"> &#125; </span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"} 
              <span className="qwerty">sports </span>
              {"\n"} 
              <span className="qwerty-1">1</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-3">football</span>
              {"\n"} 
              <span className="qwerty-1">2</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-4">badminton</span>
              {"\n"} 
              <span className="qwerty-1">3</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-5">tennis </span>
              <span className="qwerty-1">4</span>
              <span className="qwerty-2">, </span>
              <span className="qwerty-6">cricket</span>
              {"\n"}
           
            <span className="qwerty-10">hello world </span>
            <span className="qwerty-11">program </span>
            <span className="qwerty-10">in </span>
            <span className="qwerty-6">c++</span>
       
              {"\n"}{"\n"} 
              </code></pre>
        </div>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-identifier">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-input">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div></div>
    </div>
)

}
export default Cbasic;